import Vue from 'vue';
import Canvas2Image from 'canvas2image';

Vue.use(Canvas2Image)
